import { render, staticRenderFns } from "./Steen.vue?vue&type=template&id=7ecfac40&"
import script from "./Steen.vue?vue&type=script&lang=ts&"
export * from "./Steen.vue?vue&type=script&lang=ts&"
import style0 from "./Steen.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports